import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopy from './index.vue';

var InboundOrderBookingModifyBookingPage = function (_super) {
  __extends(InboundOrderBookingModifyBookingPage, _super);

  function InboundOrderBookingModifyBookingPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InboundOrderBookingModifyBookingPage = __decorate([Component({
    components: {
      AddEditCopy: AddEditCopy
    }
  })], InboundOrderBookingModifyBookingPage);
  return InboundOrderBookingModifyBookingPage;
}(Vue);

export default InboundOrderBookingModifyBookingPage;